import { Box } from '@apia/theme';
import { useContext } from 'react';
import Option from './Option';
import { AutocompleteContext } from './AutocompleteContext';

const Options = () => {
  const {
    id,
    keyhandler: { useList },
  } = useContext(AutocompleteContext);

  const options = useList();

  return (
    <Box
      className="autocomplete__optionsContainer"
      id={`list__${id}`}
      role="listbox"
      variant="layout.common.components.autocomplete.optionsContainer"
    >
      {options.map((current) => (
        <Option option={current} key={current.id} />
      ))}
    </Box>
  );
};

export default Options;
